<template>
  <div class="background_enterprise">
    <div class="enterprise_index_text">
      <p style="font-size: 22px;margin-bottom: 1vh">Portfolio</p>
      <p style="font-size: 18px; margin-bottom: 5vh;">Having obtained ownership interests in over 260 portfolio
        companies and accompanied them through full industry cycles for the past ten years, SIG has accumulated deep
        insights and extensive knowledge in various industries.</p>
      <p>SIG’s portfolio companies share experiences and resources in operation/strategy/hiring, and build business
        synergies together. Moreover, as an investor throughout Asia, we are able
        to see the trends, understand the strengths and needs in each country and are able to assist our portfolio
        companies in identifying and taking advantage of their regional opportunities.</p>
      <p>We invest with SIG’s internal capital which means we have no duration limits and have no outside limited
        partners. Therefore, SIG has its natural advantage to exercise an
        independent investment philosophy and make fast and flexible investment decisions, which helps our portfolio
        companies to concentrate on their business growth.</p>
      <div class="index_down">
        <a-button type="ghost" shape="circle-outline" size="large">
          <template v-slot:icon>
            <DownOutlined>
            </DownOutlined>
          </template>
        </a-button>
      </div>
    </div>
  </div>
</template>

<script>
import {DownOutlined} from '@ant-design/icons-vue'

export default {
  name: "Enterprise_index_en_m",
  components: {
    DownOutlined,
  },
  setup() {
    const next_page = () => {
      document.documentElement.scrollBy({
        top: window.innerHeight * 92 / 100,
        behavior: "smooth",
      })
    }
    return {next_page}
  }
}
</script>

<style scoped>
.enterprise_index_text {
  padding-top: 26vh;
  text-align: center;
}

.enterprise_index_text p {
  font-size: 11px;
  margin-bottom: 5px;
}

.background_enterprise {
  background-image: url("../../../assets/background/enterprise_index.jpg");
  height: 100vh;
  background-repeat: no-repeat;
  background-position: center;
  background-size: auto 100%;
  margin: 0;
}

</style>